import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent {
    clearSearch = '';
    value = '';

    @Output() searchEvent = new EventEmitter();
    @Output() clearSearchEvent = new EventEmitter();

    constructor() {}

    applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.searchEvent.emit(filterValue.trim().toLowerCase());
    }

    clearFilter(): void {
        this.clearSearchEvent.emit(this.clearSearch);
    }
}